import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuItemProps } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { ComponentType, createContext, MouseEventHandler, PropsWithChildren, useContext, useState } from "react";

const MenuContext = createContext<{ handleClose:()=>void }>({ handleClose:()=>{} });

export default function DataTableEntryOption({
    children
}: PropsWithChildren) {
    const [menuAnchor, setMenuAnchor] = useState<HTMLElement | undefined>();

    const handleClose = ()=>{
        setMenuAnchor(undefined)
    }

    return <>
        <IconButton size="small" onClick={(e) => setMenuAnchor(e.currentTarget)}><MoreVertIcon fontSize="small"/></IconButton>
        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleClose}>
            <MenuContext.Provider value={{handleClose}}>
                {children}
            </MenuContext.Provider>
        </Menu>
    </>
}

interface EntryOptionButtonProps extends MenuItemProps {
    Icon?: ComponentType<any>
}

function EntryOptionButton({
    Icon,
    title,
    onClick,
    ...props
}: EntryOptionButtonProps) {
    const { handleClose } = useContext(MenuContext);

    const handleClick: MouseEventHandler<HTMLLIElement> = (e) => {
        onClick && onClick(e);
        handleClose();
    }

    return <MenuItem onClick={handleClick} {...props}>
        {Icon && <ListItemIcon><Icon /></ListItemIcon>} <ListItemText>{title}</ListItemText>
    </MenuItem>
}

function EntryOptionViewButton({
    Icon = VisibilityIcon,
    title = "Ver",
    onClick,
    ...props
}:EntryOptionButtonProps){
    return <EntryOptionButton Icon={Icon} title={title} onClick={onClick} {...props}/>
}

function EntryOptionEditButton({
    Icon = EditIcon,
    title = "Editar",
    onClick,
    ...props
}: EntryOptionButtonProps) {
    return <EntryOptionButton Icon={Icon} title={title} onClick={onClick} {...props}/>
}

function EntryOptionDeleteButton({
    Icon = DeleteIcon,
    title = "Borrar",
    onClick,
    ...props
}: EntryOptionButtonProps) {
    return <EntryOptionButton Icon={Icon} title={title} onClick={onClick} {...props}/>
}

DataTableEntryOption.Button = EntryOptionButton;
DataTableEntryOption.ViewButton = EntryOptionViewButton;
DataTableEntryOption.EditButton = EntryOptionEditButton;
DataTableEntryOption.DeleteButton = EntryOptionDeleteButton;